<template>
    <div class="mobileShow">
        <div v-if="!hidden && isLoggedIn && ( msisdn!='' && msisdn!= null ) && provider == 'entel'" class="fl flex w-100 items-center bg-primary text-light justify-between">
            <div class="fl flex justify-center w-100" @click="showHelpModal">
              <div class="link-primary ttu f5 flex items-center h-100 no-underline dib pa3 white">
                <span class="">{{ $tc('provider.directLink', 2) }}</span>
              </div>
            </div>
            <div class="fl flex justify-end mr-2" v-on:click="hidden=true">
                <font-awesome-icon class="iconColor  text-white" icon="times" />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import { mapGetters } from 'vuex'

  export default {
    name: 'provider-link',
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        hidden: false
      }
    },
    methods: {
      showHelpModal () {
        this.$modal.show('direct-link-modal')
      }
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn',
        'msisdn',
        'provider'
      ])
    }
  }
</script>

<style scoped lang="scss">
    @import '~@/variables.scss';

    #alert{
        height: 50px;
        overflow-x: hidden !important;
        color: white;
        text-align: center;
        padding-top: 15px;
    }
    
    .text-white{
      color: white !important;
    }

    .mr-2{
        margin-right: 20px !important;
    }

    .mobileShow{
      display: none;
    }

    @media (max-width: 991px) { 
      .mobileShow {display: block;}
    }

</style>



// WEBPACK FOOTER //
// src/components/providerLink/ProviderLink.vue